<sk-modal-content [title]="'label.ShareLink' | translate | uppercase"
                  [cancelBtnText]="'label.Cancel'"
                  (closed)="closeWithoutResult()">

  <ng-container id="sk-modal-body">
    <div class="mb-4">
      <sk-radio-input
        [(ngModel)]="shareView"
        class="row"
        [noSubscriptBox]="true"
        [mode]="permanentLinkMode"
        [options]="shareViewOptions"
        [showClear]="false"
      ></sk-radio-input>
    </div>

    @if (isShareViewInternal) {
      <iris-copy-field
        class="share-internal"
        [value]="internalLink"
        (copied)="onCopyLink()"
      ></iris-copy-field>
    }

    @if (isShareViewExternal) {
      <iris-dms-file-share-link-external
        class="share-external"
        [file]="file"
      ></iris-dms-file-share-link-external>
    }
  </ng-container>
</sk-modal-content>
